import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import dayjs from 'dayjs';
import SimplifiedAuthCard from '../../../components/Auth/SimplifiedAuthCard';

const Login = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Login | TLK</title>
      </Helmet>
      <div className="main-body">
        <div className="main-header-s1 only-text-info">
          <h1>Welcome to TLK</h1>
          <h4>Great to see you again!</h4>
        </div>
        <div className="body-content">
          <div className="form-content-s1">
            <SimplifiedAuthCard
              initialMode="signin"
              redirectComplete="/user/creator-list"
            />
          </div>
        </div>
        <div className="bottom-cpx-text">
          <p>Copyright © {dayjs().format('YYYY')}, Syntimacy LLC</p>
        </div>
      </div>
    </>
  );
}

export default Login;
